// src/app/shared/highcharts-theme.ts
import * as Highcharts from 'highcharts';

export const HighchartsCustomTheme: Highcharts.Options = {
  chart: {
    backgroundColor: '#F0F0F0',
    style: {
      fontFamily: 'Segoe UI, Roboto, sans-serif',
    },
    plotBackgroundColor: '#F0F0F0',
    plotBorderWidth: 0,
    plotShadow: false,
  },
  title: {
    style: {
      color: '#333333',
      fontSize: '16px',
      fontWeight: 'bold',
    },
  },
  responsive: {
    rules: [{
      condition: {
        maxWidth: 500
      },
      chartOptions: {
        legend: {
          enabled: false
        }
      }
    }]
  },
  xAxis: {
    labels: {
      style: {
        color: '#333333',
      },
    },
    gridLineColor: '#F0F0F0',
    lineColor: '#cccccc',
  },
  yAxis: {
    labels: {
      style: {
        color: '#333333',
      },
    },
    gridLineColor: '#F0F0F0',
    lineColor: '#cccccc',
  },
  tooltip: {
    backgroundColor: '#ffffff',
    borderColor: '#cccccc',
    style: {
      color: '#000000',
    },
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      dataLabels: {
        enabled: false,
        style: {
          color: '#333333'
        }
      }
    }
  },
  legend: {
    itemStyle: {
      color: '#333333',
      fontWeight: 'normal',
    },
    itemHoverStyle: {
      color: '#000000',
    },
  },
  credits: {
    enabled: false,
  },
  colors: ['#8087E8', '#F79BBA', '#A3EDBA', '#FFB76C', '#669999', '#E1D369', '#87B4E7', '#DA6D85', '#BBBAC5','#8087E8'],
};